import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

/**
 * Page header — title + subtitle (+ optional inline actions).
 *
 * Does NOT add outer padding — the parent container controls spacing so
 * layouts compose cleanly.
 *
 *   <NtPageHead title="Extensions" subtitle="280 total" />
 *   <NtPageHead title="IVR Menus" subtitle="4 menus" actions={<NtButton ... />} />
 */
function NtPageHead({ title, subtitle, actions, style }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={[styles.wrap, style]}>
      <View style={{ flex: 1, minWidth: 0 }}>
        {title ? (
          <NtText style={styles.title} numberOfLines={1}>
            {title}
          </NtText>
        ) : null}
        {subtitle ? (
          <NtText style={styles.subtitle} numberOfLines={1}>
            {subtitle}
          </NtText>
        ) : null}
      </View>
      {actions ? <View style={styles.actions}>{actions}</View> : null}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    wrap: {
      flexDirection: "row",
      alignItems: "flex-end",
      gap: 12,
    },
    title: {
      fontSize: 20,
      fontWeight: "600",
      color: t.text,
      letterSpacing: -0.3,
    },
    subtitle: {
      fontSize: 12,
      color: t.textDim,
      marginTop: 2,
    },
    actions: { flexDirection: "row", alignItems: "center", gap: 8 },
  });

export default NtPageHead;
